import { render } from "./LensMakerList.vue?vue&type=template&id=4660bf35&ts=true"
import script from "./LensMakerList.vue?vue&type=script&lang=ts"
export * from "./LensMakerList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__